import React, { useEffect, useState, useRef } from "react";
import { useAppDispatch } from "../../../../../store";
import { useSelector } from "react-redux";
import * as styles from "../../../../../styles/WholedataPage";
import { RootState } from "../../../../../reducer/index";
import { Outersensors } from "../../../../../reducer/postpayloadtypes";
import axios from 'axios';

const DiaryDetailEnvironment = ({ data }: { data: any }) => {
  const dispatch = useAppDispatch();
  const { TargetDiary, Farms, Targetfarms } = useSelector(
    (state: RootState) => state.post
  );
  let [OpenEnv, setOpenEnv] = useState(true);

  const [outs, setFarmdata] = useState([]);
  const [boxs, setBoxdata] = useState([]);
  const [cons, setContainerdata] = useState([]);
  const [section, setSectiondata] = useState([]);

  const { diaryId } = data;

  // const outs = TargetDiary?.diaryEquips.dairyEquipFarm;

  // const cons = TargetDiary?.diaryEquips.diaryEquipContainer;

  // const boxs = TargetDiary?.diaryEquips.diaryEquipBox;


  useEffect(() => {
    const searchSensor = async () => {
      const targetdata = localStorage.getItem("targetfarm");
      try {
        const response = await axios.get(`/ifactory/api/diary/${data}`);
        const results = response.data;

        // farm
        setFarmdata(results.diaryEquips.dairyEquipFarm);
        setBoxdata(results.diaryEquips.diaryEquipBox);
        setContainerdata(results.diaryEquips.diaryEquipContainer);
        setSectiondata(results.diaryEquips.diaryEquipSection);


        // 농장
        // if (results[0]?.equips[0]?.sensors) {
        //   setOutersensordata(results[0].equips[0].sensors);
        // }
        // // 사육실
        // if (results[1]?.equips[0]?.sensors) {
        //   setInsensordata(results[1].equips[0].sensors);
        // }
        // // 구역
        // if (results[2]?.equips[0]?.sensors) {
        //   setSectiondata(results[2].equips[0].sensors);
        // }
        // // 박스
        // if (results[3]?.equips[0]?.sensors) {
        //   setBoxsensor(results[3].equips[0].sensors);
        // }

        // setInsensordata(results[0].equips[0].sensors);
        // setInsensordata(targetcontainer.equips[0].sensors);

      } catch (error: any) {
        console.error(error);
      }
    };
    searchSensor();
  }, []);



  return (
    <styles.EnvironmentalCon>
      <styles.Environmentaltit>
        <p className="content-tit">환경정보</p>
        <p>
          <img
            src="./img/ArrowTop.svg"
            className={OpenEnv === false ? "rotate" : ""}
            onClick={() => {
              setOpenEnv(!OpenEnv);
            }}
          />
        </p>
      </styles.Environmentaltit>
      <styles.EnvironmentalHide className={OpenEnv === false ? "hide" : ""}>
        <styles.EnvironmentalBox>
          <p className="EnvironmentalBox-tit Spoqa500">
            <span className="c-22c197 Spoqa500">외기</span> 환경정보
          </p>

          <styles.OutsideAirList>
            {outs?.map((sensors: any, idx: number) => {
              const windParser = (sensors: Outersensors) => {
                let value = sensors?.value;

                if (
                  (value >= "0" && value <= "22.5") ||
                  (value > "337.5" && value <= "360")
                ) {
                  return "북";
                }
                if (value > "22.5" && value <= "67.5") return "북동풍";
                if (value > "67.5" && value <= "112.5") return "동풍";
                if (value > "112.5" && value <= "157.5") return "남동풍";
                if (value > "157.5" && value <= "202.5") return "남풍";
                if (value > "202.5" && value <= "247.5") return "남서풍";
                if (value > "247.5" && value <= "292.5") return "서풍";
                if (value > "292.5" && value <= "337.5") return "북서풍";

                return "NO DATA";
              };

              const snsrControl = (sensors: Outersensors) => {
                let res = "";

                switch (sensors?.code) {
                  case "RAINCHECK":
                    res = sensors?.value === "1" ? "비" : "비 안옴";
                    break;
                  case "WINDDIR":
                    res = windParser(sensors);
                    break;
                  default:
                    res = sensors?.value?.toString();
                }

                return res;
              };

              return (
                <styles.OutsideAirListItem>
                  <p className="outsideair-item-tit">{sensors.name}</p>
                  <p className="outsideair-item-content">
                    {snsrControl(sensors)}
                    {sensors?.unit}
                  </p>
                </styles.OutsideAirListItem>
              );
            })}
          </styles.OutsideAirList>
        </styles.EnvironmentalBox>


        {cons && cons.length > 0 && (
          <styles.EnvironmentalBox>
            <p className="EnvironmentalBox-tit Spoqa500">
              <span key={"componunt_사육실내부 환경정보"} className="c-22c197 Spoqa500">사육실</span> 내부 환경정보
            </p>

            <styles.EnvironmentalGrap>
              {/* <styles.EnvironmentSample>
              <div className="item">
                <p className="sample bg-22C197"></p>
                <p className="text">정상</p>
              </div>
              <div className="item">
                <p className="sample"></p>
                <p className="text">위험</p>
              </div>
            </styles.EnvironmentSample> */}

              {cons?.map((sensors: any) => {
                let sensorcolor = "";
                let fontcolor = "";

                if (sensors?.status === 0) {
                  sensorcolor = "bg-22C197";
                  fontcolor = "22C197";
                } else {
                  sensorcolor = "bg-FF0000";
                  fontcolor = "FF0000";
                }

                return (
                  <styles.EnvironmentalItem>
                    <p className="env-item-title">{sensors?.name}</p>
                    <p className={`env-item-color `}>
                      <p className={`${sensorcolor}`}></p>
                    </p>
                    <p className={`env-item-value color-${fontcolor}`}>
                      {sensors?.value}
                      {sensors?.unit}
                    </p>
                  </styles.EnvironmentalItem>
                );
              })}
            </styles.EnvironmentalGrap>
          </styles.EnvironmentalBox>
        )}


        {section && section.length > 0 && (
          <styles.EnvironmentalBox>
            <p className="EnvironmentalBox-tit Spoqa500">
              <span className="c-22c197 Spoqa500">사육구역</span> 내부 환경정보
            </p>
            <styles.EnvironmentalGrap>
              {/* <styles.EnvironmentSample>
                <div className="item">
                  <p className="sample bg-22C197"></p>
                  <p className="text">정상</p>
                </div>
                <div className="item">
                  <p className="sample"></p>
                  <p className="text">위험</p>
                </div>
              </styles.EnvironmentSample> */}
              {section &&
                section.map((sensor: any, idx: Number) => {
                  let sensorcolor = "";
                  let fontcolor = "";

                  sensorcolor = "bg-22C197";
                  fontcolor = "22C197";

                  if (sensor?.status === 0) {
                    sensorcolor = "bg-22C197";
                    fontcolor = "22C197";
                  } else {
                    sensorcolor = "bg-FF0000";
                    fontcolor = "FF0000";
                  }

                  // if (
                  //   sensor.value >= sensor.tagRange.alarmLowerLimit &&
                  //   sensor.value <= sensor.tagRange.alarmUpperLimit
                  // ) {
                  //   sensorcolor = "bg-22C197";
                  //   fontcolor = "22C197";
                  // } else {
                  //   sensorcolor = "bg-FF0000";
                  //   fontcolor = "FF0000";
                  // }

                  return (
                    <styles.EnvironmentalItem key={sensor?.tagId}>
                      <p className="env-item-title">{sensor?.name}</p>
                      <p className={`env-item-color `}>
                        <p className={`${sensorcolor}`}></p>
                      </p>
                      <p className={`env-item-value color-${fontcolor}`}>
                        {sensor?.value}
                        {sensor?.unit}
                      </p>
                    </styles.EnvironmentalItem>
                  );
                })}
            </styles.EnvironmentalGrap>
          </styles.EnvironmentalBox>
        )}




        {boxs && boxs.length > 0 && (
          <styles.EnvironmentalBox>
            <p className="EnvironmentalBox-tit Spoqa500">
              <span className="c-22c197 Spoqa500">사육상자</span> 내부 환경정보
            </p>

            <styles.BreedingBoxBot></styles.BreedingBoxBot>
            <styles.EnvironmentalGrap>
              {/* <styles.EnvironmentSample>
                <div className="item">
                  <p className="sample bg-22C197"></p>
                  <p className="text">정상</p>
                </div>
                <div className="item">
                  <p className="sample"></p>
                  <p className="text">위험</p>
                </div>
              </styles.EnvironmentSample> */}
              {boxs?.map((sensor: any, idx: number) => {
                let sensorcolor = "";
                let fontcolor = "";

                if (sensor?.status === 0) {
                  sensorcolor = "bg-22C197";
                  fontcolor = "22C197";
                } else {
                  sensorcolor = "bg-FF0000";
                  fontcolor = "FF0000";
                }

                return (
                  <styles.EnvironmentalItem>
                    <p className="env-item-title">{sensor?.name}</p>
                    <p className={`env-item-color `}>
                      <p className={`${sensorcolor}`}></p>
                    </p>
                    <p className={`env-item-value color-${fontcolor}`}>
                      {sensor?.value}
                      {sensor?.unit}
                    </p>
                  </styles.EnvironmentalItem>
                );
              })}
            </styles.EnvironmentalGrap>
          </styles.EnvironmentalBox>

        )}

      </styles.EnvironmentalHide>
    </styles.EnvironmentalCon>
  );
};

export default DiaryDetailEnvironment;
